export class DragDropData {
    name: string;
    additionalData: any[];
    isDisabled = false;
    isEmptyDropRow = false;
    externalName: string;
    tooltip: string;
    // mode: string;   // this indicates are we adding or removing.

    constructor(value?: Partial<DragDropData>) {
        if (value) {
            Object.assign(this, value);
        }
    }
}
